import { GlobalWorkerOptions, getDocument } from "pdfjs-dist";
import workerSrc from "pdfjs-dist/build/pdf.worker.min.mjs?url";

// Empacota o worker pelo Vite e aponta para ele
GlobalWorkerOptions.workerSrc = workerSrc;

// Exporte apenas o que você usa
export { getDocument };
